import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import startsWith from 'lodash/startsWith'
import noop from 'lodash/noop'
import get from 'lodash/get'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'

import CustomerAnonymous from './CustomerAnonymous'
import UnifiedIdentification from './UnifiedIdentification/UnifiedIdentificationContainer'
import { orderFormIdSelector } from '@/checkout-instore-legacy/order/selectors'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

class CustomerIdentification extends React.Component {
  constructor(props) {
    super(props)
    this.next = props.location.query.next
  }

  hasOrderForm() {
    const { orderForm } = this.props.order
    const orderFormId = orderFormIdSelector(getReduxStore().getState())
    return orderForm && orderForm.orderFormId && orderFormId
  }

  componentDidMount() {
    const { order } = this.props
    const next = this.next
      ? startsWith(this.next, '/')
        ? this.next
        : `/${this.next}`
      : null

    if (this.hasOrderForm()) {
      if (this.next) {
        this.continueToNext()
      }
    } else {
      if (!order.loading) {
        this.props.loadInStoreOrderForm(
          this.props.vendor,
          undefined,
          next ? this.props.router : undefined,
          next
        )
      }
    }

    const clientIdentification = get(this, 'props.location.query.client')
    if (clientIdentification) {
      this.handleSetCustomerIdentification(clientIdentification)
      return
    }

    CustomEvent.listenEvent(
      'setCustomerIdentification',
      this.handleSetCustomerIdentificationEvent
    )

    window.customizeCustomerIdentification = true

    CustomEvent.sendEvent('customizeCustomerIdentification', {})
  }

  componentWillUnmount() {
    window.customizeCustomerIdentification = false
    CustomEvent.unlistenEvent(
      'setCustomerIdentification',
      this.handleSetCustomerIdentificationEvent
    )
  }

  componentDidUpdate() {
    const { onLoading } = this.props
    if (this.hasOrderForm()) {
      if (this.identification) {
        this.next
          ? this.continueToNext()
          : this.continueToCart(this.identification)
        onLoading(false)
      } else if (this.next) {
        this.continueToNext()
      }
    }
  }

  handleSetCustomerIdentificationEvent = (event) => {
    const identification =
      event && event.data && (event.data.email || event.data.document)
    if (identification) {
      this.handleSetCustomerIdentification(identification)
    }
  }

  handleSetCustomerIdentification = (identification) => {
    const { onLoading } = this.props
    this.identification = identification

    if (this.hasOrderForm()) {
      this.continueToCart(identification)
    } else {
      onLoading(true)
    }
  }

  handleChangeIdentificationType = (data) => {
    this.props.changeIdentificationType(data)
  }

  continueToNext = () => {
    const next = startsWith(this.next, '/') ? this.next : `/${this.next}`
    this.props.router.push(next)
  }

  continueToCart = (identification) => {
    this.props.clearCustomer()
    if (!this.isSameCustomer(identification)) {
      this.props.setCustomer({
        identification,
        router: this.props.router,
      })
    } else {
      this.props.router.push('/cart')
    }
  }

  isSameCustomer(identification) {
    const orderForm = this.props.order.orderForm
    const currentEmail =
      orderForm && orderForm.clientProfileData
        ? orderForm.clientProfileData.email
        : null
    const currentDocument =
      orderForm && orderForm.clientProfileData
        ? orderForm.clientProfileData.document
        : null
    const isSameDocument = identification && identification === currentDocument
    return isSameDocument || identification === currentEmail
  }

  render() {
    const { order } = this.props
    const identificationType = order.identificationType
    const { orderForm } = order
    const { allowAnonymousUser } = getInstoreConfig()

    return (
      <div className="pt6 flex-auto flex-column">
        <div className="tc mb6-ns mb0">
          <div className="flex justify-center">
            <div className="f2-ns f3 tc fw7 tc w-30-l pt6-l pb0">
              <FormattedMessage id="clientLabelIdentify" />
              <br /> <FormattedMessage id="clientLabel" />
            </div>
          </div>
        </div>

        <UnifiedIdentification
          identificationType={identificationType}
          onSetCustomerIdentification={this.handleSetCustomerIdentification}
          orderForm={orderForm}
        />

        <div className="flex justify-center">
          <div className="w-30-l tc ph5 mid-gray lh-copy f6 f5-ns mt5">
            <FormattedMessage id="identificationDisclaimer" />
          </div>
        </div>

        {allowAnonymousUser && (
          <CustomerAnonymous
            onSetCustomerIdentification={this.handleSetCustomerIdentification}
          />
        )}
      </div>
    )
  }
}

CustomerIdentification.propTypes = {
  clearCustomer: PropTypes.func.isRequired,
  location: PropTypes.object,
  router: PropTypes.object,
  route: PropTypes.object,
  onLoading: PropTypes.func,
  visible: PropTypes.bool,
  order: PropTypes.object,
  loadInStoreOrderForm: PropTypes.func.isRequired,
  setCustomer: PropTypes.func.isRequired,
  changeIdentificationType: PropTypes.func.isRequired,
  vendor: PropTypes.object,
}

CustomerIdentification.defaultProps = {
  onLoading: noop,
  visible: true,
}

export default withRouter(CustomerIdentification)
